"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBytesFromMb = void 0;
const getBytesFromMb = (mb) => {
    return mb * 1024 * 1024;
};
exports.getBytesFromMb = getBytesFromMb;
